export enum ESubmissionDocumentType {
  IdentityCardFront = '03',
  IdentityCardBack = '04',
  IncomeDocumentPaysip = '10'
}